import { render, staticRenderFns } from "./profile-view-documentation.vue?vue&type=template&id=419f2a3d&scoped=true"
import script from "./profile-view-documentation.vue?vue&type=script&lang=js"
export * from "./profile-view-documentation.vue?vue&type=script&lang=js"
import style0 from "./profile-view-documentation.vue?vue&type=style&index=0&id=419f2a3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419f2a3d",
  null
  
)

export default component.exports